var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLongNarrowArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0398 17.0997C9.64793 17.0997 9.33029 16.7639 9.33029 16.3497L9.33029 2.34973C9.33029 1.93552 9.64793 1.59973 10.0398 1.59973C10.4316 1.59973 10.7492 1.93552 10.7492 2.34973L10.7492 16.3497C10.7492 16.7639 10.4316 17.0997 10.0398 17.0997Z",
    fill: "#676879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5473 17.3802C10.2702 17.673 9.8211 17.6729 9.54408 17.3801L5.74309 14.1604C5.46603 13.8675 5.46603 13.3926 5.74309 13.0997C6.02015 12.8068 6.46935 12.8068 6.74641 13.0997L10.0459 15.7892L13.2537 13.0995C13.5309 12.8066 13.9801 12.8068 14.257 13.0997C14.534 13.3927 14.5339 13.8676 14.2568 14.1604L10.5473 17.3802Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongNarrowArrow);
export default __webpack_public_path__ + "static/media/long-narrow-arrow.f2db04f5.svg";
export { ForwardRef as ReactComponent };